import Vue from 'vue'
import App from './App.vue'

import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueQRCodeComponent from 'vue-qrcode-component'


Vue.use(VueAxios, axios)
Vue.component('qr-code', VueQRCodeComponent)

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
